import { observerQuote } from '../utils';

document.addEventListener("DOMContentLoaded", () => {

  // Load More on Scroll
  const quoteList = document.querySelector('.row-quotes .et_pb_code_inner > div:last-child');

  if(quoteList) {
    observerQuote(quoteList);
  }

});


// WEBPACK FOOTER //
// ./src/js/pages/quotes.js